var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashbookSidebarIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#485667;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.6,14.5h-1l0-11.7c0-1.2-1-2.2-2.2-2.2l-12.6,0c-1.2,0-2.2,1-2.2,2.2v3.1c0,0.5,0.4,0.8,0.8,0.8h1.9v10.4 c0,0.6,0.2,1.2,0.7,1.6c0.4,0.4,0.9,0.6,1.5,0.6h11.7c1.2,0,2.2-1,2.2-2.2v-1.8C19.4,14.9,19,14.5,18.6,14.5z M3.3,2.8v2.3H2.2 l0-2.3c0-0.3,0.2-0.5,0.5-0.5C3.1,2.3,3.3,2.5,3.3,2.8z M4.9,2.3h10.5c0.3,0,0.5,0.2,0.5,0.5v11.7H6.8c-0.5,0-0.8,0.4-0.8,0.8V17 c0,0.3-0.2,0.6-0.5,0.6c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.2-0.2-0.2-0.4V2.8C4.9,2.6,4.9,2.4,4.9,2.3z M17.7,16.1v1 c0,0.3-0.2,0.5-0.5,0.5H7.6c0.1-0.2,0.1-0.4,0.1-0.6v-0.9H17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,10.4h6.1c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6H7c-0.3,0-0.6,0.3-0.6,0.6S6.7,10.4,7,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,13h7.3c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6H7c-0.3,0-0.6,0.3-0.6,0.6S6.7,13,7,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.6,6.8c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2L9.5,6.9C9.6,7,9.7,7.1,9.8,7.2 c0.1,0.1,0.3,0.1,0.4,0.2c0.1,0,0.3,0.1,0.4,0.1c0.3,0,0.6-0.1,0.8-0.2c0.2-0.1,0.3-0.3,0.3-0.6c0-0.2,0-0.3-0.1-0.4 C11.6,6.1,11.5,6,11.4,6c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.1s-0.1-0.1-0.1-0.1 c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.3,0.2l0.5-0.5c-0.1-0.1-0.3-0.3-0.4-0.3 c-0.2-0.1-0.4-0.1-0.6-0.1c-0.2,0-0.4,0-0.5,0.1S9.9,5,9.8,5.1C9.7,5.3,9.7,5.4,9.7,5.6c0,0.2,0,0.3,0.1,0.4C9.8,6,9.9,6.1,10,6.2 c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1 C10.8,6.8,10.7,6.8,10.6,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.4,5.8L7.4,5.8l1.2,1.5h1L8.4,5.8c0.1,0,0.2-0.1,0.3-0.1C8.9,5.6,9,5.5,9.1,5.3C9.2,5.2,9.3,5,9.3,4.8 c0-0.2-0.1-0.4-0.2-0.6C9,4,8.9,3.9,8.7,3.8C8.5,3.7,8.3,3.7,8.1,3.7H7.4H7.2H6.6v3.7h0.8V5.8z M7.4,4.3H8c0.2,0,0.3,0,0.4,0.1 c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.3-0.1,0.3C8.3,5.2,8.1,5.2,8,5.2H7.4V4.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashbookSidebarIconNew);
export default __webpack_public_path__ + "static/media/CashbookSidebarIconNew.69a1d99e8c4400f77147db1403031d43.svg";
export { ForwardRef as ReactComponent };